import { render, staticRenderFns } from "./deduct_score.vue?vue&type=template&id=3871ab16&scoped=true&"
import script from "./deduct_score.vue?vue&type=script&lang=js&"
export * from "./deduct_score.vue?vue&type=script&lang=js&"
import style0 from "./deduct_score.vue?vue&type=style&index=0&id=3871ab16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3871ab16",
  null
  
)

export default component.exports